import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalWindow from '@common/components/modal/modal-window';
import ModalContent from '@common/components/modal/modal-content';
import { EvaluationFormTypes } from '@common/definitions';

type AIModuleFormProps = {
  onOpenCourse: (type: EvaluationFormTypes) => void;
  children: React.ReactNode;
};

const CreateEvaluationModal = memo(
  ({ onOpenCourse, children }: AIModuleFormProps) => {
    const [show, setShow] = useState(false);
    const { t } = useTranslation();

    const handleHide = () => {
      setShow(false);
    };

    const handleShow = () => {
      setShow(true);
    };

    const handleManagerAndEmployeeCreate = () => {
      onOpenCourse(EvaluationFormTypes.MANAGER_EMPLOYEE);
      handleHide();
    };

    const handleEmployeeCreate = () => {
      onOpenCourse(EvaluationFormTypes.MANAGER);
      handleHide();
    };

    return (
      <ModalWindow
        trigger={children}
        show={show}
        onHide={handleHide}
        onShow={handleShow}
        size="small"
      >
        <ModalContent title={t('performance:new_form')} onHide={handleHide} hideFooter>
          <div className="tw-flex tw-flex-col tw-gap-4">
            <div
              className="tw-flex tw-p-5 tw-border-[1px] tw-rounded-lg tw-border-solid
              tw-border-[#E4E4E7] tw-cursor-pointer hover:tw-bg-gray-neutral-50"
              onClick={handleManagerAndEmployeeCreate}
            >
              <div
                className="!tw-w-[30px] tw-mr-4 tw-rounded tw-bg-no-repeat !tw-mt-[6px]"
                style={{ backgroundImage: 'url(/static/images/multi-user.png)' }}
              />
              <div className="tw-flex tw-flex-col tw-gap-1">
                <h3 className="tw-font-inter">{t('performance:manager_employee')}</h3>
                <div className="tw-font-inter tw-font-normal tw-text-sm tw-text-gray-text">
                  {
                    t('performance:manager_employee_description')
                  }
                </div>
              </div>
            </div>
            <div
              className="tw-flex tw-p-5 tw-border-[1px] tw-rounded-lg tw-border-solid
              tw-border-[#E4E4E7] tw-cursor-pointer hover:tw-bg-gray-neutral-50"
              onClick={handleEmployeeCreate}
            >
              <div
                className="!tw-w-[30px] tw-mr-4 tw-rounded tw-bg-no-repeat !tw-mt-1"
                style={{ backgroundImage: 'url(/static/images/single-user.png)' }}
              />
              <div className="tw-flex tw-flex-col tw-gap-1">
                <h3 className="tw-font-inter">{t('performance:manager_only')}</h3>
                <div className="tw-font-inter tw-font-normal tw-text-sm tw-text-gray-text">
                  {
                    t('performance:manager_only_description')
                  }
                </div>
              </div>
            </div>
          </div>
        </ModalContent>
      </ModalWindow>
    );
  }
);

export default CreateEvaluationModal;
